<div
    *ngIf="!!currentFlowStep"
    id="upload-invoices-page"
    class="min-full-height-content d-flex flex-column"
    [ngClass]="{ 'is-dragged-over': isDraggedOver }"
>
    <lsq-banner
        [titleText]="title"
        [hasContent]="bannerStepTabsShouldDisplay()"
        [includeDateFilterStringPlaceholder]="false"
        contentSide="right"
    >
        <lsq-banner-step-tabs
            [(activeStep)]="currentFlowStep"
            [allStepsComplete]="currentFlowStep === flowSteps[3]"
            [steps]="[flowSteps[1], flowSteps[2]]"
        >
        </lsq-banner-step-tabs>
    </lsq-banner>

    <div
        class="upload-invoices-page-content container-fluid d-flex justify-content-center align-items-center flex-column"
    >
        <lsq-circle-loader
            *ngIf="!didCheckForUploadMethodPreference || !availableUploadMethodOptions.length"
        ></lsq-circle-loader>

        <ng-container
            *ngIf="didCheckForUploadMethodPreference && !!availableUploadMethodOptions.length"
        >
            <!-- Upload method selection -->
            <div
                *ngIf="currentFlowStep.step === invoiceUploadFlowStep.UploadOptionsSelection"
                class="upload-invoices-method-selection"
            >
                <h2
                    class="font-weight-normal text-center h1"
                    i18n="
                        Heading prompting the user to choose their preferred method for uploading
                        invoices.
                    "
                >
                    How will you be uploading your invoices today?
                </h2>

                <lsq-upload-invoices-options
                    [options]="availableUploadMethodOptions"
                    (select)="handleUploadMethodSelect($event)"
                >
                </lsq-upload-invoices-options>
            </div>

            <!-- Upload -->
            <div
                *ngIf="!!invoiceBatchService.selectedUploadMethodOption"
                class="upload-invoices-upload"
                [ngClass]="{ loading: isSubmittingInvoiceBatch }"
            >
                <ng-container *ngIf="isCoverSheetStep()">
                    <div class="cover-sheet-step">
                        <lsq-upload-invoices-cover-sheet></lsq-upload-invoices-cover-sheet>
                    </div>
                </ng-container>

                <ng-container *ngIf="isUploadStep()">
                    <div class="upload-step">
                        <h2 class="text-center h1">
                            <ng-container
                                *ngIf="invoiceBatchService.isCombinedImagesUploadMethodSelected()"
                            >
                                <ng-container
                                    i18n="
                                        Part 1/2 of: 'Next, upload your documents by dragging them
                                        anywhere on the screen'
                                    "
                                >
                                    Next, upload your combined documents<!--
                                --></ng-container
                                ><!--
                                --><span
                                    *ngIf="!(responsiveService.smBelow | async)"
                                    i18n="
                                        Part 2/2 of: 'Next, upload your documents by dragging them
                                        anywhere on the screen'
                                    "
                                >
                                    by dragging them anywhere on the screen<!--
                                --></span
                                >.
                            </ng-container>
                            <ng-container
                                *ngIf="invoiceBatchService.isSpreadsheetUploadMethodSelected()"
                            >
                                <ng-container
                                    i18n="
                                        Part 1/2 of: 'Next, upload your spreadsheet by dragging it
                                        anywhere on the screen'
                                    "
                                >
                                    Next, upload your spreadsheet<!--
                                --></ng-container
                                ><!--
                                --><span
                                    *ngIf="!(responsiveService.smBelow | async)"
                                    i18n="
                                        Part 2/2 of: 'Next, upload your spreadsheet by dragging it
                                        anywhere on the screen'
                                    "
                                >
                                    by dragging it anywhere on the screen<!--
                                --></span
                                >.
                            </ng-container>
                        </h2>

                        <ng-container *ngIf="!(responsiveService.smBelow | async)">
                            <div
                                *ngIf="!!invoiceFileUploads.length && canUpload()"
                                id="sub-header-select-files"
                                class="file-select-group"
                            >
                                <span i18n>or </span>
                                <a
                                    href="javascript:void(0)"
                                    (click)="handleFileSelectLinkClick()"
                                    i18n="Button prompting the user to upload files"
                                >
                                    Select files
                                </a>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="responsiveService.smBelow | async">
                            <div
                                *ngIf="!!invoiceFileUploads.length && canUpload()"
                                id="sub-header-select-files"
                                class="file-select-group"
                            >
                                <a
                                    href="javascript:void(0)"
                                    (click)="handleFileSelectLinkClick()"
                                    i18n="Button prompting the user to upload additional files"
                                >
                                    Select more files
                                </a>
                            </div>
                        </ng-container>

                        <div class="upload-invoices-zone-container file-select-group">
                            <lsq-upload-invoices-zone
                                [uploadMethod]="invoiceBatchService.selectedUploadMethodOption"
                                [isDraggedOver]="isDraggedOver"
                                [fileUploads]="invoiceFileUploads"
                                (reorder)="invoiceFileUploads = $event"
                                [isSpreadsheetUpload]="
                                    invoiceBatchService.selectedUploadMethodOption?.method ===
                                    invoiceBatchUploadMethod.SpreadsheetAndBackupUpload
                                "
                                (fileSelect)="handleFileSelectLinkClick()"
                            >
                            </lsq-upload-invoices-zone>
                        </div>
                    </div>

                    <div
                        *ngIf="
                            invoiceBatchService.isCombinedImagesUploadMethodSelected() &&
                            !(responsiveService.smBelow | async)
                        "
                        class="mobile-invoice-upload-form"
                    >
                        <div id="enter-mobile-phone-number">
                            <ng-container
                                i18n="
                                    Part 1/3 of: 'or enter your mobile phone number to easily upload
                                    files from your mobile device.'
                                "
                                >or enter your</ng-container
                            >
                            <form
                                id="mobile-phone-form"
                                class="d-inline-block align-middle"
                                [formGroup]="mobileFormGroup"
                            >
                                <lsq-input
                                    i18n-label="
                                        Part 2/3 of: 'or enter your mobile phone number to easily
                                        upload files from your mobile device.'
                                    "
                                    label="Mobile Phone Number"
                                    name="phone"
                                    [group]="mobileFormGroup"
                                    [mask]="masks.PhoneMask"
                                    type="tel"
                                    [unmask]="phoneUnmask"
                                    formControlName="phone"
                                >
                                </lsq-input>
                                <lsq-button
                                    type="submit"
                                    [group]="mobileFormGroup"
                                    [disabled]="!canSendMobileLink()"
                                    (buttonClick)="sendSmsMessage()"
                                >
                                    <span *ngIf="mobileLinkSent" i18n="Resend link button"
                                        >Resend Link</span
                                    >
                                    <span *ngIf="!mobileLinkSent" i18n="Send link button"
                                        >Send Link</span
                                    >
                                </lsq-button>
                            </form>
                            <ng-container
                                i18n="
                                    Part 3/3 of: 'or enter your mobile phone number to easily upload
                                    files from your mobile device.'
                                "
                            >
                                to easily upload files from your mobile device.
                            </ng-container>
                            <popover-content #mobileUploadInstructions>
                                <ol>
                                    <li
                                        i18n="
                                            Step 1/4 of the instructions for using the mobile upload
                                            feature
                                        "
                                    >
                                        Send link via SMS to your mobile phone (standard rates
                                        apply)
                                    </li>
                                    <li
                                        i18n="
                                            Step 2/4 of the instructions for using the mobile upload
                                            feature
                                        "
                                    >
                                        Click the link on your device
                                    </li>
                                    <li
                                        i18n="
                                            Step 3/4 of the instructions for using the mobile upload
                                            feature
                                        "
                                    >
                                        Select an image from your photo library or take a photo with
                                        your device's camera
                                    </li>
                                    <li
                                        i18n="
                                            Step 4/4 of the instructions for using the mobile upload
                                            feature
                                        "
                                    >
                                        Your upload will automatically appear on this page
                                    </li>
                                </ol>
                            </popover-content>
                            <lsq-icon
                                [type]="icons.Info"
                                [color]="color.Gray"
                                [popover]="mobileUploadInstructions"
                            >
                            </lsq-icon>
                            <div *ngIf="mobileLinkSent" class="navigation-warning text-center">
                                <lsq-icon [type]="icons.AlertWarning"></lsq-icon>
                                <ng-container i18n>
                                    The link has been sent. Do not navigate away from this page.
                                    Your uploads will appear above.
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="upload-invoices-success" *ngIf="isSuccessScreen()">
                <lsq-icon [type]="icons.CheckmarkCircleLarge" [color]="color.Green"></lsq-icon>
                <h2
                    *ngIf="uploadedInvoicesCount !== undefined"
                    class="upload-invoices-success-title"
                >
                    <ng-container i18n="Heading alerting the user that the upload was successful">
                        You successfully submitted { uploadedInvoicesCount, plural, =1 {1 file}
                        other {{{uploadedInvoicesCount}} files} } to LSQ with a stated total of
                    </ng-container>
                    {{ lastStatedTotalStream | async | currency }}.
                </h2>

                <p class="upload-invoices-success-subtitle">{{ getInvoiceSuccessMessage() }}</p>
                <lsq-button
                    class="upload-invoices-success-upload-more"
                    (buttonClick)="startOver()"
                    i18n="
                        Button prompting the user to continue uploading invoices (after a successful
                        upload)
                    "
                >
                    Upload More Invoices
                </lsq-button>
                <lsq-button
                    class="upload-invoices-success-view-history-link"
                    appearance="transparent"
                    (buttonClick)="goToUploadHistory()"
                    i18n="
                        Button prompting the user to view their upload history (after a successful
                        upload)
                    "
                >
                    View Invoice Upload History
                </lsq-button>
            </div>

            <div class="upload-invoices-failure" *ngIf="isFailureScreen()">
                <lsq-icon [type]="icons.XCircle" [color]="color.Red"></lsq-icon>
                <h2 class="upload-invoices-failure-title">
                    <ng-container
                        i18n="Part 1/2 of: 'There was an error submitting your invoices...'"
                    >
                        There was an error submitting your invoices.
                    </ng-container>
                    <br />
                    <ng-container
                        i18n="Part 2/2 of: 'There was an error submitting your invoices...'"
                    >
                        Please try again. Contact customer support if the problem persists.
                    </ng-container>
                </h2>
                <lsq-button
                    class="upload-invoices-failure-upload-more"
                    (buttonClick)="startOver()"
                    i18n="
                        Button prompting the user to retry uploading invoices (after a failed
                        upload)
                    "
                >
                    Upload Invoices
                </lsq-button>
            </div>

            <div *ngIf="isSubmittingInvoiceBatch" class="submit-loader">
                <lsq-circle-loader></lsq-circle-loader>
            </div>
        </ng-container>
    </div>

    <lsq-upload-invoices-footer
        *ngIf="currentFlowStep?.step !== invoiceUploadFlowStep.UploadOptionsSelection"
        [showBack]="shouldDisplayBackButton()"
        [showContinue]="isCoverSheetStep()"
        [showSubmit]="isUploadStep()"
        [showBackToDashboard]="isSuccessScreen()"
        [disableBack]="isSubmittingInvoiceBatch"
        [disableContinue]="disableContinueStream | async"
        [disableSubmit]="disableSubmitStream | async"
        [isSubmitting]="isSubmittingInvoiceBatch"
        (submit)="handleSubmit()"
        (navigate)="handleNavigate($event)"
    >
    </lsq-upload-invoices-footer>
</div>
